module.exports = __webpack_public_path__ + "static/media/polinizador.178c3a4e.svg";